/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
`

export default function LiveTagIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="14" viewBox="0 0 23 14" css={Color} className="mix-tag-icon">
      <g id="그룹_19139" data-name="그룹 19139" transform="translate(-161 -411)">
        <g id="사각형_11309" data-name="사각형 11309" transform="translate(161 411)" fill="#141414" stroke="#141414"
           strokeWidth="1">
          <rect width="23" height="14" rx="3" stroke="none"/>
          <rect x="0.5" y="0.5" width="22" height="13" rx="2.5" fill="none"/>
        </g>
        <text id="MIX" transform="translate(165 421)" fill="#eee" fontSize="8" fontFamily="Roboto-Black, Roboto"
              fontWeight="800" letterSpacing="0.02em">
          <tspan x="0" y="0">MIX</tspan>
        </text>
      </g>
    </svg>

  )
}
